module.exports = __webpack_public_path__ + "media/tabata_rest.ed15afbd.wav";